import { render, staticRenderFns } from "./politiqueDeConfidentialite.vue?vue&type=template&id=2bb181a6"
import script from "./politiqueDeConfidentialite.vue?vue&type=script&lang=js"
export * from "./politiqueDeConfidentialite.vue?vue&type=script&lang=js"
import style0 from "./politiqueDeConfidentialite.vue?vue&type=style&index=0&id=2bb181a6&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMentionsLegales: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/HeaderMentionsLegales.vue').default})
